import { Injectable } from '@angular/core';
import { Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthOnlyGuard {
  constructor(
    private _authService: AuthService,
    private _router: Router
  ) {}

  canMatch(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._check(segments);
  }

  private _check(segments: UrlSegment[]): Observable<boolean | UrlTree> {
    return this._authService.check().pipe(
      switchMap((authenticated) => {
        if (authenticated) {
          return of(true);
        }

        const path = `/${segments.join('/')}`;
        const queryParams = this._router.getCurrentNavigation()?.extractedUrl?.queryParams ?? {};
        const search = new URLSearchParams();
        Object.entries(queryParams).forEach(([key, value]) => {
          if (value != null) search.set(key, String(value));
        });
        const queryString = search.toString();
        const redirectURL = queryString ? `${path}?${queryString}` : path;

        const urlTree = this._router.createUrlTree(['/auth/sign-in'], {
          queryParams: { redirectURL },
        });
        return of(urlTree);
      })
    );
  }
}
